import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root' 
})
export class EventBusService {
  private userListRefreshSource = new Subject<void>();  
  userListRefresh$ = this.userListRefreshSource.asObservable();

  private associateListRefreshSource = new Subject<void>(); 
  associateListRefresh$ = this.associateListRefreshSource.asObservable();

  private projectListRefreshSource = new Subject<void>(); 
  projectListRefreshSource$ = this.projectListRefreshSource.asObservable();

  private selectedCompanyRefreshSource = new Subject<void>();  
  selectedCompanyRefresh$ = this.selectedCompanyRefreshSource.asObservable();

  refreshUserList() {
    this.userListRefreshSource.next();
  }

  refreshAssociateList() {
    this.associateListRefreshSource.next(); 
  }

  refreshProjectList() {
    this.projectListRefreshSource.next();
  }

  refreshSelectedCompany() {
    this.selectedCompanyRefreshSource.next();
  }
}